import React, { useState } from "react";

import "../../../Assets/CSS/bulkorder.css";
import "../../OMS/oms.css";

import SupplierDetailsForm from "../forms/supplierDetails";
import POBOSSupplierForm from "../forms/poBosSupplier";
import ProductDetailsSupplierForm from "../forms/productDetailsSupplier";
import LoadingDetailsSupplierForm from "../forms/loadingDetailsSupplier";
import TransportDetailSupplierForm from "../forms/transportDetailsSupplier";
import RejectionDetailSupplierForm from "../forms/rejectionDetailsSupplier";
import PaymentDetailSupplierForm from "../forms/paymentDetailsSupplier";
import DocumentSupplierForm from "../forms/documentsSupplier";

import MandiDetailSupplier from "../forms/mandiDetailsSupplier";
import SupplierPayemntsDetails from "../forms/supplierPayemntsDetails";
import SupplierContractExecution from "../forms/buyer/supplierContractExecution";
import OrderBrokerage from "../forms/orderBrokerage";

function SupplierSide({ omsData, getOMSData, id }) {
  const [selectedDataInventory, setSelectedDataInventory] = useState({});
  const [selectedDataSupplier, setSelectedDataSupplier] = useState({});

  return (
    <>
      {
        <div className=" ms-0 ps-0">
          <div className=" gap-2 ">
            <SupplierDetailsForm
              setSelectedDataInventory={setSelectedDataInventory}
              setSelectedDataSupplier={setSelectedDataSupplier}
              orderId={id}
              getOMSData={getOMSData}
              opSourcingDetails={omsData?.op_sourcing_details?.[0] || {}}
              omsData={omsData}
            />
            <POBOSSupplierForm
              omsData={omsData}
              orderId={id}
              poBosUploads={omsData?.operations_po_bos_uploads}
              getOMSData={getOMSData}
            />
            <ProductDetailsSupplierForm omsData={omsData} />
            <LoadingDetailsSupplierForm
              omsData={omsData}
              orderId={id}
              getOMSData={getOMSData}
            />
            <TransportDetailSupplierForm
              omsData={omsData}
              orderId={id}
              getOMSData={getOMSData}
              orderShipmentDocs={omsData?.order_shipment_docs}
            />
            <SupplierPayemntsDetails
              orderId={id}
              omsData={omsData}
              // orderId={id}
              // getOMSData={getOMSData}
            />
            {/* <SupplierDetailsForm orderId={id} getOMSData={getOMSData} /> */}
            <MandiDetailSupplier
              orderId={id}
              omsData={omsData}
              getOMSData={getOMSData}
              orderShipmentDocs={omsData?.order_shipment_docs}
            />
            {/*<RejectionDetailSupplierForm />*/}
            <PaymentDetailSupplierForm
              paymentData={omsData.only_bnps}
              paymentRequest={omsData.oms_payment_requests}
              getOMSData={getOMSData}
              orderId={id}
              omsData={omsData}
            />
            <SupplierContractExecution
              omsData={omsData}
              getOMSData={getOMSData}
              orderId={id}
            />
            <OrderBrokerage
              omsData={omsData}
              orderId={id}
              merchantType="supplier"
              getOMSData={getOMSData}
            />
          </div>
        </div>
      }
    </>
  );
}

export default SupplierSide;
